import {Injectable, NgZone} from '@angular/core';
import {PKEY} from '../../constants/persistence.constants';
import {PersistenceService} from './persistence.service';
import {Cliente} from "../models/cliente.model";
import {Operador} from "../models/operador.model";


export interface Session {
  token: string;
  user_id: string | number;
  user: string;
  mail?: string;
  cliente?: Cliente;
  operador?: Operador;
  operadorList?: Operador[];
  allowed_locales?: AllowedLocal[];
  url_origin?: string;
  url_redirect?: string;
  terms_conditions?: string;
  type_container?: string;
  permissions?: string;
  type?: string;
}

export interface AllowedLocal {
  local_id: string;
  local_name: string;
}


@Injectable()
export class AuthService {
  public userLoginExpireAt = 0;
  private MESSAGE_EXPIRATION_TIME = 15;
  private interval: any = null;
  private showingExpiration = false;

  constructor(
    private persistence: PersistenceService,
    private zone: NgZone
  ) {

    /*this.userLoginExpireAt = this.persistence.get(PKEY.USER_LOGIN_EXPIRE);

    if (this.isAuthenticated) {
      this.verifyLoginExpire();
    }*/
  }

  get notifyExpiresAt() {
    return this.userLoginExpireAt - (this.MESSAGE_EXPIRATION_TIME * 30 * 1e3);
  }

  createSession(data: Session) {
    // this.userLoginExpireAt = data.expire * 1e3;

    this.persistence.set(PKEY.USER_TOKEN, data.token);
    this.persistence.set(PKEY.USER_NAME, data.user);
    this.persistence.set(PKEY.USER_MAIL, data.mail);
    this.persistence.set(PKEY.USER_ID, data.user_id);
    this.persistence.set(PKEY.CLIENTE, data.cliente);
    this.persistence.set(PKEY.ALLOWED_LOCALES, data.allowed_locales);
    this.persistence.set(PKEY.OPERADOR_LIST, data.operadorList);
    this.persistence.set(PKEY.OPERADOR, data.operador);
    this.persistence.set(PKEY.URL_ORIGIN, data.url_origin);
    this.persistence.set(PKEY.URL_REDIRECT, data.url_redirect);
    this.persistence.set(PKEY.TERMS_CONDITIONS, data.terms_conditions);
    this.persistence.set(PKEY.TYPE_CONTAINER, data.type_container);
    this.persistence.set(PKEY.PRIVIGELES, data.permissions);
    this.persistence.set(PKEY.TYPE, data.type);


    clearInterval(this.interval);
  }




  clearUserSession(): void {
    clearInterval(this.interval);

    this.persistence.remove(PKEY.USER_TOKEN);
    this.persistence.remove(PKEY.USER_NAME);
    this.persistence.remove(PKEY.USER_MAIL);
    this.persistence.remove(PKEY.USER_ID);
    this.persistence.remove(PKEY.CLIENTE);
    this.persistence.remove(PKEY.ALLOWED_LOCALES);
    this.persistence.remove(PKEY.OPERADOR_LIST);
    this.persistence.remove(PKEY.URL_ORIGIN);
    this.persistence.remove(PKEY.URL_REDIRECT);
    this.persistence.remove(PKEY.OPERADOR);
    this.persistence.remove(PKEY.CLIENTE);
    this.persistence.remove(PKEY.TERMS_CONDITIONS);
    this.persistence.remove(PKEY.TYPE_CONTAINER);
    this.persistence.remove(PKEY.SEARCH_CLIENTE_ID);
    this.persistence.remove(PKEY.PRIVIGELES);
    this.persistence.remove(PKEY.TYPE);
    this.persistence.removeCookie(PKEY.COOKIE_ID, false);
  }

}

